// Formats d'affichage : heure du Gabon (UTC+1), libellés métier.

import {
  DEFINITIONS_ROLES,
  LIBELLES_CATEGORIES,
  LIBELLES_CONFIDENTIALITE,
  LIBELLES_ETATS,
  LIBELLES_TYPES_ORGANISATIONS,
  type CategorieInstallation,
  type EtatValidation,
  type NiveauConfidentialite,
  type Role,
  type TypeOrganisation,
} from '@carburanttrack/shared';

const FORMAT_DATE_HEURE = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Africa/Libreville', dateStyle: 'medium', timeStyle: 'short' });
const FORMAT_DATE = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Africa/Libreville', dateStyle: 'medium' });

export function dateHeure(iso: string | null | undefined): string {
  return iso ? FORMAT_DATE_HEURE.format(new Date(iso)) : 'indisponible';
}

export function date(iso: string | null | undefined): string {
  return iso ? FORMAT_DATE.format(new Date(iso)) : 'indisponible';
}

const FORMAT_JOUR = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Africa/Libreville', weekday: 'long', day: 'numeric', month: 'long' });
const FORMAT_HEURE = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Africa/Libreville', hour: '2-digit', minute: '2-digit' });

/** Jour courant en toutes lettres, heure du Gabon (« dimanche 18 octobre »). */
export function jourLong(d: Date = new Date()): string {
  return FORMAT_JOUR.format(d);
}

/** Heure et minutes, heure du Gabon (« 14:02 »). */
export function heure(d: Date | number): string {
  return FORMAT_HEURE.format(typeof d === 'number' ? new Date(d) : d);
}

export const libelleCategorie = (c: string) => LIBELLES_CATEGORIES[c as CategorieInstallation] ?? c;
export const libelleEtat = (e: string) => LIBELLES_ETATS[e as EtatValidation] ?? e;
export const libelleConfidentialite = (n: string) => LIBELLES_CONFIDENTIALITE[n as NiveauConfidentialite] ?? n;
export const libelleRole = (r: string) => DEFINITIONS_ROLES[r as Role]?.libelle ?? r;
export const libelleTypeOrganisation = (t: string) => LIBELLES_TYPES_ORGANISATIONS[t as TypeOrganisation] ?? t;

export const NOMS_PROVINCES: Record<string, string> = {
  'GA-1': 'Estuaire',
  'GA-2': 'Haut-Ogooué',
  'GA-3': 'Moyen-Ogooué',
  'GA-4': 'Ngounié',
  'GA-5': 'Nyanga',
  'GA-6': 'Ogooué-Ivindo',
  'GA-7': 'Ogooué-Lolo',
  'GA-8': 'Ogooué-Maritime',
  'GA-9': 'Woleu-Ntem',
};

export const libelleProvince = (code: string | null | undefined) => (code ? NOMS_PROVINCES[code] ?? code : 'indisponible');

export function classeEtat(etat: string): string {
  if (etat === 'valide') return 'etiquette';
  if (etat === 'en_attente_validation') return 'etiquette ambre';
  if (etat === 'annule' || etat === 'archive') return 'etiquette gris';
  return 'etiquette';
}
